import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getMNCForMCC'
})
export class GetMNCForMCCPipe implements PipeTransform {

  transform(mnc: number, mcc: number, mccmncList: any[]): unknown {
    const found = mccmncList.find(c => c.mcc === Number(mcc) && c.mnc === Number(mnc));
    return found ? found.network : mnc;
  }

}
